import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Row,
  ToggleButton,
  ToggleButtonGroup,
} from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import supabase from "../../supabase";
import { useNotification } from "../../context/NotificationContext";

const PaiementPage = () => {
  const { user } = useAuth();
  const { showNotification } = useNotification();
  const [billingCycle, setBillingCycle] = useState("annuel"); // 🔹 "annuel" par défaut
  const [currentPlan, setCurrentPlan] = useState(null);
  const [searchParams] = useSearchParams();
  const desiredPlan = searchParams.get("plan");

  const plans = {
    Free: {
      price: "0€",
      details: "1 bien par mois, Analyse limitée à 10 pièces",
    },
    Pro: {
      annuel: { price: "4,99€", stripeId: process.env.STRIPEPRICE_ABOPRO_ANNUEL },
      mensuel: { price: "6,99€", stripeId: process.env.STRIPEPRICE_ABOPRO_MENSUEL },
      details: "3 biens par mois",
    },
    Entreprise: { price: "Nous contacter", details: "Solution sur mesure" },
  };

  useEffect(() => {
    if (user?.id) {
      fetchUserPlan();
    }
    if(desiredPlan === 'Pro')
    {
      handleCheckout('Pro')
    }
  }, [user, desiredPlan, fetchUserPlan, handleCheckout]);

  const fetchUserPlan = async () => {
    const { data, error } = await supabase
      .from("profiles")
      .select("plan")
      .eq("id", user.id)
      .single();
    if (!error && data?.plan) {
      setCurrentPlan(data.plan);
    }
  };

  const handleCheckout = async (plan) => {
    if (!user) {
      showNotification("Vous devez être connecté !", "warning");
      return;
    }

    const priceId = plans[plan][billingCycle]?.stripeId; // 🔹 Récupère l'ID du prix dynamique

    if (!priceId) {
      showNotification("Erreur : ID du prix non trouvé !", "danger");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/stripe/create-checkout-session`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            priceId,
            userId: user.id,
            email: user.email,
            plan: plan
          }),
        }
      );

      const data = await response.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        showNotification("Erreur lors de la création de la session de paiement.", "danger");
      }
    } catch (error) {
      console.error("Erreur de connexion avec le serveur :", error);
      showNotification("Erreur de connexion avec le serveur.", "danger");
    }
  };

  return (
    <Container className="mt-5">
      <h2 className="text-center mb-4">Choisissez un abonnement</h2>

      {/* Sélecteur Mensuel / Annuel */}
      <div className="text-center mb-4">
        <ToggleButtonGroup
          type="radio"
          name="billingCycle"
          defaultValue="annuel"
          onChange={setBillingCycle}
        >
          <ToggleButton id="tbg-btn-1" value="annuel" variant="outline-primary">
            Annuel
          </ToggleButton>
          <ToggleButton
            id="tbg-btn-2"
            value="mensuel"
            variant="outline-secondary"
          >
            Mensuel
          </ToggleButton>
        </ToggleButtonGroup>
      </div>

      <Row className="justify-content-center">
        {Object.keys(plans).map((plan) => {
          const isCurrentPlan = currentPlan === plan;
          return (
            <Col md={3} key={plan}>
              <Card
                className={`text-center h-100 d-flex flex-column shadow-sm ${isCurrentPlan ? "border-primary" : ""}`}
              >
                <Card.Body className="d-flex flex-column">
                  <Card.Title>
                    {plan}{" "}
                    {isCurrentPlan && (
                      <Badge bg="primary" style={{ backgroundColor: 'var(--primary-dark-text)' }}>Votre abonnement</Badge>
                    )}
                  </Card.Title>
                  <Card.Text className="flex-grow-1">
                    <strong>
                      {plans[plan][billingCycle]?.price || plans[plan].price}
                    </strong>
                    <br /> {plans[plan].details}
                  </Card.Text>
                  {isCurrentPlan ? (
                    <Button variant="success" disabled>
                      Abonnement actif ✅
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      onClick={() => handleCheckout(plan)}
                      style={{ backgroundColor: 'var(--accent-orange)', borderColor: 'var(--accent-orange)' }}
                    >
                      Passer à {plan}
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default PaiementPage;
